import userService from "@/services/userService"
import api from "@/api"

const messages = {
  HEALTH_BUSY: "Die Freigabe für Apple Health ist noch geöffnet.",
  HEALTH_AUTHORIZATION_INCOMPLETE: "Die Freigabe wurde nicht abgeschlossen. Du kannst es erneut versuchen.",
  HEALTH_WORKOUT_UNAVAILABLE: "Dieses Uhrtraining ist nicht mehr freigegeben oder wurde gelöscht. Bitte erneut suchen.",
  HEALTH_READ_FAILED: "Apple Health konnte nicht gelesen werden. Entsperre dein iPhone und versuche es erneut.",
}

async function nativeCall(method, payload = {}) {
  const userId = String(userService.getUserId() || "")
  const token = window.__wellcomeHealthImportToken
  if (!userId || !token || !window.flutter_inappwebview?.callHandler) return { supported: false }
  let timeout
  try {
    const response = await Promise.race([
      window.flutter_inappwebview.callHandler(method, { ...payload, bridgeToken: token }),
      new Promise((_, reject) => {
        timeout = setTimeout(() => reject(new Error("Apple Health antwortet noch nicht. Bitte erneut versuchen.")), method === "healthImportAuthorize" ? 300000 : 30000)
      }),
    ])
    if (String(userService.getUserId() || "") !== userId || token !== window.__wellcomeHealthImportToken) {
      throw new Error("Die Anmeldung hat sich geändert. Bitte das Training erneut öffnen.")
    }
    if (response?.accepted === false) throw new Error(messages[response.code] || response.error || messages.HEALTH_READ_FAILED)
    return response || { supported: false }
  } finally { clearTimeout(timeout) }
}

function requireSupported(result) {
  if (result?.supported !== true) throw new Error("Der Apple-Health-Import benötigt die aktuelle iPhone-App.")
  return result
}

export default {
  async available() {
    try { return (await nativeCall("healthImportCapabilities"))?.supported === true } catch (_) { return false }
  },
  async authorize() { return requireSupported(await nativeCall("healthImportAuthorize")) },
  async search(range) {
    const userId = String(userService.getUserId() || "")
    const result = requireSupported(await nativeCall("healthImportSearch", range))
    const workouts = Array.isArray(result.workouts) ? result.workouts : []
    // Only IDs leave the phone during search. Full health data leaves it only
    // after the user confirms one workout for their own existing execution.
    const availability = workouts.length ? await api.workoutApi.getHealthWorkoutLinks(workouts.map((item) => item.workoutId)) : { links: [] }
    if (userId !== String(userService.getUserId() || "")) throw new Error("Die Anmeldung hat sich geändert. Bitte erneut suchen.")
    return { workouts: workouts.map((item) => ({ ...item, existingLink: availability.links.find((link) => link.workoutId === item.workoutId) || null })), truncated: result.truncated === true }
  },
  async read(workoutId) {
    return requireSupported(await nativeCall("healthImportRead", { workoutId })).workout
  },
}
